import React, {useCallback, useEffect, useMemo, useState} from "react";
import {noop} from "../../../lib/misc/noop";
import {BasicNumber} from "../../../components/form-v2/basic-text";
import BasicSelect from "../../../components/form-v2/basic-select";

export type IntervalFormat = "hour" | "minute" | "second";

type IntervalInputProps = {
    label?: string;
    initialValue: number;
    initialFormat: IntervalFormat;
    onChange: (value: number, formattedValue: number, format: IntervalFormat) => void;
    showInitial?: boolean;
}

export function IntervalInput({
    label,
    initialValue,
    initialFormat,
    onChange = noop,
    showInitial = false,
                              }: IntervalInputProps) {


    const [format, setFormat] = useState<IntervalFormat>(initialFormat);

    const multiplierFunc = useCallback((format: string) => {
        switch (format) {
            case "hour":
                return 3600;
            case "minute":
                return 60;
        }
        return 1;
    }, [])

    const multiplier = useMemo(() =>  {
       return multiplierFunc(format)
    }, [format, multiplierFunc]);

    const [value, setValue] = useState<number>(initialValue / multiplier);


    useEffect(() => {
        onChange(value * multiplier, value, format)
    }, [value, format]);

    const options = useMemo(() => {
        return [
            {value: "second", label: "Seconds"},
            {value: "minute", label: "Minutes"},
            {value: "hour", label: "Hours"},
        ]
    }, [])



    return (
        <div>
            {label && (<label className="mb-1">{label}</label>)}
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <BasicNumber disabled={showInitial} align="left" type="number" value={showInitial ? (initialValue / multiplierFunc(initialFormat) ) : value} onChange={setValue} min={0} max={99}/>
                </div>
                <div>
                    <BasicSelect disabled={showInitial} options={options} onChange={(v) => setFormat(v as IntervalFormat)} value={showInitial ? initialFormat : format}/>

                </div>
            </div>

        </div>
    )

}